<!--
 * @Descripttion: 
 * @version: 
 * @Author: ysoshuaibing
 * @Date: 2022-07-18 10:46:23
 * @LastEditors: DESKTOP-IV14688
 * @LastEditTime: 2023-10-26 16:14:50
-->
<template>
  <div :class="{ btn }">
    <div v-if="!tip || isMobile" :style="getStyle" class="fc svg-wrap">
      <svg class="svg-icon" :class="{ rotating: spinning }">
        <use :xlink:href="symbolId" />
      </svg>
    </div>
    <u-tooltip
      v-if="tip && !isMobile"
      :title="tip"
      :placement="placement"
      :offset="offset"
      dropdown-class="bot-keyframe-show"
    >
      <div :style="getStyle" class="fc svg-wrap">
        <svg class="svg-icon">
          <use :xlink:href="symbolId" />
        </svg>
      </div>
    </u-tooltip>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
import { isMobileDevice } from '@libs/tools';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    tip: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    },
    selectedColor: {
      type: String,
      default: 'var(--theme-color)'
    },
    prefix: {
      type: String,
      default: 'svg-icon'
    },
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    },

    color: {
      type: String,
      default: undefined
    },

    padding: {
      type: [Number, String, Array],
      default: 6
    },

    btn: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    placement: {
      type: String,
      default: 'top'
    },
    rotate: {
      type: [Number, String],
      default: 0
    },
    spinning: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const offset = computed(() => {
      return props.placement === 'right' ? [0, 8] : [0, 2];
    });
    const symbolId = computed(() => `#${props.prefix}-${props.name}`);
    const getStyle = computed(() => {
      const { size, width, height } = props;
      const w = width || size;
      const h = height || size;
      const s1 = `${w}`.replace('px', '').concat('px');
      const s2 = `${h}`.replace('px', '').concat('px');
      const padding = Array.isArray(props.padding)
        ? props.padding.map(item => `${item}px`).join(' ')
        : `${props.padding}px`;
      return {
        width: s1,
        height: s2,
        color: props.selected ? props.selectedColor : props.color,
        padding,
        transform: `rotate(${props.rotate}deg)`
      };
    });
    const isMobile = isMobileDevice();
    return {
      isMobile,
      getStyle,
      symbolId,
      offset
    };
  }
});
</script>

<style lang="less" scoped>
.svg-wrap {
  box-sizing: content-box;
  .svg {
    width: 100%;
    height: 100%;
  }
}
.svg-icon {
  overflow: hidden;
  vertical-align: -0.15em;
  fill: currentColor;
  width: 100%;
  height: 100%;
  outline: none;
  display: inline;
}
.btn {
  cursor: pointer;
}
.rotating {
  animation: rotate 1s linear infinite;
  transform-origin: 50% 50%;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.tool-tip {
  z-index: 50000;
}
.bot-keyframe-show {
  z-index: 1;
}
</style>